import { render } from "./UserForbidden.vue?vue&type=template&id=43d902e4&scoped=true"
const script = {}

import "./UserForbidden.vue?vue&type=style&index=0&id=43d902e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d902e4"]])

export default __exports__